/**
 * Site navigation. This drives both the desktop dropdown menu and the mobile
 * accordion, and mirrors the route table in App.jsx.
 *
 * A top-level item with `children` is a menu trigger; without them it is a
 * plain link. `href` on a parent gives the section its own landing page so
 * keyboard and screen-reader users always have somewhere to land.
 */
export const navigation = [
  {
    label: 'Visiting?',
    href: '/visiting',
    children: [
      { label: 'Location, Service & Times', href: '/visiting/location-service-times' },
      { label: 'Shuttle Bus Transportation', href: '/visiting/shuttle-bus' },
    ],
  },
  {
    label: 'News & Events',
    href: '/news-events',
    children: [{ label: 'Calendar', href: '/news-events/calendar' }],
  },
  {
    label: 'Watch Online',
    href: '/watch',
    children: [
      { label: 'Watch LIVE', href: '/watch/live' },
      { label: 'Past Services', href: '/watch/past-services' },
    ],
  },
  {
    label: 'Christian Education',
    href: '/education',
    children: [
      { label: 'Bible Study', href: '/education/bible-study' },
      { label: 'Committed Kids', href: '/education/committed-kids' },
    ],
  },
  {
    label: 'Outreach',
    href: '/outreach',
    children: [{ label: 'Clothes Closet', href: '/outreach/clothes-closet' }],
  },
  {
    label: 'Give',
    href: '/give',
    children: [{ label: 'Ways to Give', href: '/give/ways-to-give' }],
  },
  {
    label: 'About',
    href: '/about',
    children: [
      { label: 'Staff', href: '/about/staff' },
      { label: 'Vision & Mission', href: '/about/vision-mission' },
      { label: 'What We Believe', href: '/about/what-we-believe' },
      { label: 'Our History', href: '/about/history' },
    ],
  },
  {
    label: 'Contact Us',
    href: '/contact',
  },
];
